module.exports = __webpack_public_path__ + "img/reveal-tasting.42c5439c.jpg";